// extracted by mini-css-extract-plugin
export default {"button":"button_button__2l_um","button_outline":"button_button_outline__15m9x","btn_sm":"button_btn_sm__XO0tR"};